import React from 'react';
import PropTypes from 'prop-types';
import { getEntityUrl } from '@culture/utils/helpers/entities';
import { getMicrodata } from '@culture/common-helpers/microdata';

import EntityPropTypes from 'propTypes/entities';

import {
	cardCropTextDefault,
	cardIcons,
	imageCardSizeDefault
} from 'utils/helpers/entities';

import BaseCard from './BaseCard';

const InstituteCard = ({
	className,
	cropTextParams,
	entity,
	hasMicrodata,
	nextLink,
	params,
	typeWidth
}) => {
	const {
		accessibility,
		city,
		federalSubject,
		isPushkinsCard,
		locale,
		thumbnailFile,
		title,
		virtualTours
	} = entity;
	const url = getEntityUrl('institutes', entity);
	const description = city?.title || locale?.title || federalSubject?.title;
	const cardBadges = [];
	const microdata =
		hasMicrodata && (entity?.microdata || getMicrodata(entity, 'institutes'));

	if (isPushkinsCard) {
		cardBadges.push(cardIcons.pushkin);
	}

	if (virtualTours?.length) {
		cardBadges.push(cardIcons.virtualTour);
	}

	if (accessibility?.length) {
		cardBadges.push(cardIcons.accessible);
	}

	return (
		<BaseCard
			{...{
				className,
				cropTextParams,
				description,
				microdata,
				nextLink,
				params,
				thumbnailFile,
				title,
				typeWidth,
				url
			}}
			badges={cardBadges}
			placeholderImage="institutes"
		/>
	);
};

InstituteCard.propTypes = {
	className: PropTypes.string,
	cropTextParams: PropTypes.shape({
		title: PropTypes.string,
		description: PropTypes.string
	}),
	entity: EntityPropTypes.institute.isRequired,
	hasMicrodata: PropTypes.bool,
	nextLink: PropTypes.bool,
	params: PropTypes.shape({
		width: PropTypes.number.isRequired,
		height: PropTypes.number.isRequired
	}),
	typeWidth: PropTypes.oneOf([
		'fluidLandscapeSlide',
		'fixedLandscape',
		'landingLandscape'
	])
};

InstituteCard.defaultProps = {
	cropTextParams: cardCropTextDefault,
	params: imageCardSizeDefault.landscape
};

export default InstituteCard;
